exports.IonRangeSliderModule = require('./lib/ion-range-slider.module').IonRangeSliderModule;
exports.IonRangeSliderComponent = require('./lib/ion-range-slider.component').IonRangeSliderComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-ion-range-slider/index.js
// module id = ./node_modules/ng2-ion-range-slider/index.js
// module chunks = vendor